import React from 'react';
import DialogModal from '@/modules/common/components/Modal/DialogModal';
import { Button, Typography } from '@pw-tech/omni-ui';
import { XCircle, Info } from 'lucide-react';
type Props = {
  isOpen: boolean;
  isLoading?: boolean;
  onContinueWithCEE: () => void;
};
const TrackShiftModal = ({
  isOpen,
  isLoading = false,
  onContinueWithCEE
}: Props) => {
  return <DialogModal isOpen={isOpen} title="" onClose={() => null} onSubmit={() => null} showHeader={false} showSeparator={false} showFooter={false} showCancelButton={false} showSubmitButton={false} closeOnOutsideClick={false} showCloseIcon={false} size="large" data-sentry-element="DialogModal" data-sentry-component="TrackShiftModal" data-sentry-source-file="TrackShiftModal.tsx">
      <div className="flex flex-col items-center gap-6 py-4">
        {/* Rejected Banner */}
        <div className="flex flex-col items-center gap-2 w-full rounded-xl border border-red-200 bg-red-50 px-6 py-6">
          <XCircle size={40} className="text-red-700 fill-red-700 stroke-white" data-sentry-element="XCircle" data-sentry-source-file="TrackShiftModal.tsx" />
          <Typography variant="heading3" weight="semi-bold" className="!text-[#1A1A1A]" data-sentry-element="Typography" data-sentry-source-file="TrackShiftModal.tsx">
            Application Rejected
          </Typography>
          <Typography variant="regular" className="!text-[#6B6B6B]" data-sentry-element="Typography" data-sentry-source-file="TrackShiftModal.tsx">
            You are not eligible for Fast Track Admission Process
          </Typography>
        </div>

        {/* Info Text */}
        <div className="flex items-start gap-2 w-full px-2">
          <Info size={18} className="text-[#6B6B6B] mt-0.5 flex-shrink-0" data-sentry-element="Info" data-sentry-source-file="TrackShiftModal.tsx" />
          <Typography variant="regular" className="!text-[#3D3D3D] !text-sm" data-sentry-element="Typography" data-sentry-source-file="TrackShiftModal.tsx">
            The document you submitted does not qualify for Fast Track Process. You can still
            proceed with your application through the Common Entrance Test (CEE)
          </Typography>
        </div>

        {/* CTA Button */}
        <Button variant="primary" onClick={onContinueWithCEE} className="w-full max-w-xs" disabled={isLoading} data-sentry-element="Button" data-sentry-source-file="TrackShiftModal.tsx">
          {isLoading ? 'Processing...' : 'Continue With CEE Application'}
        </Button>
      </div>
    </DialogModal>;
};
export default TrackShiftModal;